export default function round(value, places) {
  // allow 0, which will just return the number as an int.
  if (places == null) {
    // default is hundredths, 2 decimal places.
    places = 2;
  }
  const power = Math.pow(10, places);
  return Math.round(value * power) / power;
}
